import { Check } from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import React from 'react';

interface StepConnectorIconProps {
  active?: boolean;
  completed?: boolean;
}

const StepConnectorIcon: React.FC<StepConnectorIconProps> = ({
  active,
  completed,
}: StepConnectorIconProps) => {
  const IconBox = styled(Box)(() => ({
    marginTop: 4,
    width: 20,
    height: 20,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    ...(completed && {
      backgroundColor: '#1DD566',
      color: '#fff',
    }),
    ...(active &&
      !completed && {
        backgroundColor: '#0047FF',
      }),
    ...(!active &&
      !completed && {
        backgroundColor: '#e5e8ebff',
      }),
  }));

  const ActiveIcon = styled(Box)(() => ({
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: active ? '#fff' : '#D0D5DD',
  }));

  return <IconBox>{completed ? <Check sx={{ fontSize: 14 }} /> : <ActiveIcon />}</IconBox>;
};

export default StepConnectorIcon;
